import React, { useState } from 'react';
import { Toggle } from '@core/uilibrary';
import TextFieldInline from '../../../../../../component-controller-mod/component-serv/input-fs-cp/text-field-op/ts/textFieldInline';

export const DraftTextField: React.FC<{
  initialValue?: string;
  placeholder?:  string;
  onChange:      (v: string) => void;
}> = ({ initialValue = '', placeholder, onChange }) => {
  const [draft, setDraft] = useState(initialValue);
  return (
    <TextFieldInline
      value={draft}
      placeholder={placeholder}
      onChange={(v: string) => { setDraft(v); onChange(v); }}
    />
  );
};

export const LabelRow: React.FC<{
  label:     string;
  required?: boolean;
  toggle?:   { checked: boolean; onChange: (v: boolean) => void };
}> = ({ label, required, toggle }) => (
  <div className="scl--cms-content-edit-navigation-label-row">
    <span
      className="scl--cms-content-edit-navigation-label"
      style={toggle ? { fontWeight: 600 } : undefined}
    >
      {label}{required && <span className="scl--cms-content-edit-navigation-required"> *</span>}
    </span>
    {toggle && <Toggle checked={toggle.checked} onChange={toggle.onChange} />}
  </div>
);

export const SplitRow: React.FC<{
  currentText: string;
  children:    React.ReactNode;
}> = ({ currentText, children }) => (
  <div className="scl--cms-content-edit-navigation-split-row">
    <div className="scl--cms-content-edit-navigation-split-accent" />
    <div className="scl--cms-content-edit-navigation-split-body">
      <span className="scl--cms-content-edit-navigation-split-current">{currentText}</span>
      <div className="scl--cms-content-edit-navigation-split-slot">{children}</div>
    </div>
  </div>
);